<template>
  <a-modal :title="title"
           :width="800"
           :ok="false"
           :visible="visible"
           :confirmLoading="confirmLoading"
           :okButtonProps="{ props: { disabled: disableSubmit } }"
           @ok="handleOk"
           @cancel="handleCancel"
           :cancelText="$t('button.close')">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.organizationName" :hidden="false" hasFeedback>
          <a-input v-decorator="['departName', validatorRules.departName]"
                   :read-only="checkField('departName')"
                   @click="openLangModal('departName', true)"
                   :placeholder="$t('label.pleaseEnterOrganizationName')" />
        </mtc-form-item>
        <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :hidden="seen" label="label.upperDivision" hasFeedback>
          <a-tree-select style="width: 100%"
                         :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                         :treeData="departTree"
                         v-model="model.parentId"
                         :placeholder="$t('label.pleaseSelectHigherDepartmentision')"
                         :disabled="condition">
          </a-tree-select>
        </mtc-form-item>
        <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.personIncharge">
          <a-select :placeholder="$t('label.pleaseSelectPersonIncharge')" v-decorator="['leaderId']">
            <a-select-option v-for="item in leaderList" :key="item.id" :value="item.id">
              {{ item.realname }}
            </a-select-option>
          </a-select>
        </mtc-form-item>
        <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.divisionHead">
          <a-select :placeholder="$t('label.pleaseSelectDivisionHead')" v-decorator="['assignerId']">
            <a-select-option v-for="item in assignerList" :key="item.id" :value="item.id">
              {{ item.realname }}
            </a-select-option>
          </a-select>
        </mtc-form-item>
        <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.departAdmin">
          <a-select :placeholder="$t('label.pleaseSelectDepartAdmin')" v-decorator="['deptAdmin']">
            <a-select-option v-for="item in deptAdminList" :key="item.id" :value="item.id">
              {{ item.realname }}
            </a-select-option>
          </a-select>
        </mtc-form-item>
        <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.orgType">
          <template >
            <a-radio-group v-decorator="['orgCategory', validatorRules.orgCategory]" :placeholder="$t('label.pleaseSelectOrgType')">
              <a-radio v-for="(item, key) in departsList" :key="key" :value="item.value">{{ item.text }}</a-radio>
            </a-radio-group>
          </template>
        </mtc-form-item>
        <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.phoneNumber">
          <a-input :placeholder="$t('label.pleaseEnterTelephone')" v-decorator="['mobile', validatorRules.mobile]" />
        </mtc-form-item>
        <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.fax">
          <a-input :placeholder="$t('label.pleaseEnterFax')" v-decorator="['fax', {}]" />
        </mtc-form-item>
        <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.addressOnly">
          <a-input :placeholder="$t('label.pleaseSelectAddress')" v-decorator="['address', {}]" />
        </mtc-form-item>
        <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.sort">
          <a-input-number v-decorator="['departOrder', { initialValue: 0 }]" />
        </mtc-form-item>
        <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.remarks">
          <a-textarea :placeholder="$t('label.pleaseEnterANote')" v-decorator="['memo', {}]" />
        </mtc-form-item>
      </a-form>
    </a-spin>
    <mtc-lang-modal />
  </a-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import { queryIdTree, getAllUserList,ajaxGetDictItems } from '@/api/api'
import pick from 'lodash.pick'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import { mtcLangModalMixin } from '@/mixins/mtcLangModalMixin'
import langInputMixin from '@/mixins/langInputMixin'
import { setLangInputParams } from '@/utils/langUtils'
import { MTC_AUTH } from '@api/servers'

export default {
  name: 'SysDepartModal',
  mixins: [mtcLangModalMixin, langInputMixin],
  components: { ATextarea },
  data() {
    return {
      mainTable: 'sys_depart',
      departTree: [],
      orgTypeData: [],
      phoneWarning: '',
      departName: '',
      title: '操作',
      seen: false,
      visible: false,
      condition: true,
      disableSubmit: false,
      model: {},
      menuhidden: false,
      menuusing: true,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      // form: this.$form.createForm(this),
      validatorRules: {
        departName: { rules: [{ required: true, message: this.$t('label.pleaseEnterOrganizationName') }] },
        orgCode: { rules: [{ required: true, message: this.$t('label.pleaseEnterTheOrganizationCode') }] },
        mobile: { rules: [{ validator: this.validateMobile }] }
      },
      url: {
        add: `${MTC_AUTH}sys/sysDepart/add`
      },
      dictDisabled: true,
      leaderList: [], //负责人
      assignerList: [], //分管领导
      deptAdminList: [],//部门管理员
      departsList: []
    }
  },
  created() {
    this.initDepartList();
  },
  methods: {
    initDepartList(){
      ajaxGetDictItems('org_category', null).then((res) => {
        if (res.success) {
          this.departsList = res.result;
        }
      });
    },
    loadTreeData() {
      var that = this
      queryIdTree().then((res) => {
        if (res.success) {
          that.departTree = []
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[ i ]
            that.departTree.push(temp)
          }
        }
      })
    },
    add(depart) {
      if (depart) {
        this.seen = false
        this.dictDisabled = false
      } else {
        this.seen = true
        this.dictDisabled = true
      }
      this.edit(depart)
    },
    edit(record) {
      this.getLangForm(this.mainTable)
      this.form.resetFields()
      this.model = Object.assign({}, {})
      this.visible = true
      this.loadTreeData()
      this.model.parentId = record != null? record.toString(): null
      if (this.seen) {
        this.model.orgCategory = '1'
      } else {
        this.model.orgCategory = '2'
      }
      this.getUserList()
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'orgCategory',
            'departName',
            'departNameEn',
            'departNameAbbr',
            'departOrder',
            'description',
            'orgType',
            'orgCode',
            'mobile',
            'fax',
            'address',
            'memo',
            'status',
            'delFlag',
            'assignerId',
            'leaderId',
            'deptAdmin'
          )
        )
      })
    },
    getUserList() {
      getAllUserList().then((res) => {
        this.leaderList = res.result
        this.assignerList = res.result
        this.deptAdminList = res.result
      })
    },
    close() {
      this.$emit('close')
      this.disableSubmit = false
      this.visible = false
    },
    // handleOk() {
    //   const that = this
    //   // 触发表单验证
    //   this.form.validateFields((err, values) => {
    //     if (!err) {
    //       that.confirmLoading = true
    //       let formData = Object.assign(this.model, values)
    //       //时间格式化
    //       console.log(formData)
    //       httpAction(this.url.add, formData, 'post')
    //         .then((res) => {
    //           if (res.success) {
    //             that.$message.success(res.message)
    //             that.loadTreeData()
    //             that.$emit('ok')
    //           } else {
    //             that.$message.warning(res.message)
    //           }
    //         })
    //         .finally(() => {
    //           that.confirmLoading = false
    //           that.close()
    //         })
    //     }
    //   })
    // },
    handleCancel() {
      this.close()
    },
    validateMobile(rule, value, callback) {
      if (!value || new RegExp(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/).test(value)) {
        callback()
      } else {
        callback(this.$t('tip.yourPhoneNumberIncorrect'))
      }
    }
  }
}
</script>

<style scoped>
</style>